import { render, staticRenderFns } from "./nameCustomer.vue?vue&type=template&id=6f533f34&scoped=true"
import script from "./nameCustomer.vue?vue&type=script&lang=js"
export * from "./nameCustomer.vue?vue&type=script&lang=js"
import style0 from "./nameCustomer.vue?vue&type=style&index=0&id=6f533f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f533f34",
  null
  
)

export default component.exports